import { useEffect, useState } from "react";

import Masonry from 'react-masonry-css';
import { useLocation } from "react-router-dom";
import { getNft, getNfts } from "../api";
import { useWall } from "../App";
import { TextDivider } from "../components";
import Parallax from '../components/Parallax';
import {
  Flex,
  GalleryContainer, LoadingContainer, SkeletonContainer
} from "../style";
import { isValidAddress, parseName, parseURL } from '../utils';
import { utils } from "../variables";
import { breaks, getCols } from './Gallery';

const CustomWall = () => {
  const { nfts, loading, setLoading, setSnackbar } = useWall();
  const [walletAddress, setWalletAddress] = useState("");
  const [name, setName] = useState("");
  const [list, setList] = useState(nfts);
  const [breakpoints, setBreakpoints] = useState(breaks);

  const location = useLocation();

  const loadNfts = async () => {
    try {
      const response = await getNfts(walletAddress, true);
      return response.data.nfts;
    } catch (error) {
      console.error(error);
    }
  };

  const getBreakpoints = () => {
    if (list && list.length <= 5 && window.innerWidth >= 1501) {
      return setBreakpoints({
        default: list.length
      })
    }
    return setBreakpoints(breaks);
  }

  const loadWall = async (nfts) => {
    try {
      if (nfts) {
        const newResps = nfts.map(async ({ token_uri }) => {
          return getNft(token_uri)
            .then((res) => res.data)
            .catch((error) => {
              if (error && error.response) {
                const status = error.response.status;
                if (status === 403)
                  setSnackbar({
                    show: true,
                    content:
                      "Some of your NFTS are private and couldn't be accessed",
                    severity: "warning",
                  });
              }
            });
        });

        return Promise.all(newResps).then((data) =>
          data.filter((elem) => elem)
        );
      }
    } catch (error) {
      setSnackbar({
        show: true,
        content: "We couldn't access your NFTS",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    const urlData = parseURL(location.pathname);
    if (urlData) {
      const { address, name } = urlData;
      const validAddress = isValidAddress(address);
      if (validAddress) {
        setWalletAddress(address);
      } else {
        setSnackbar({
          show: true,
          content: "Invalid ETH address",
          severity: "error",
        });
      }
      const parsedName = parseName(name);
      setName(parsedName);
    }
  }, []);

  useEffect(() => {
    try {
      if (walletAddress) {
        loadNfts().then((nfts) =>
          loadWall(nfts).then((data) => {
            setLoading(false);
            setList(data);
          })
        );
      }
    } catch (error) {
    }
  }, [walletAddress]);

  const [columns, setColumns] = useState(getCols(window.innerWidth));

  useEffect(() => {
    window.addEventListener('resize', getBreakpoints);
    return () => window.removeEventListener('resize', getBreakpoints);
  }, []);
  return (
    <Flex
      width={utils.width.fullVW}
      justifyContent="center"
      alignItems="center"
      backgroundColor="white"
      flexDirection="column"
    >
      <TextDivider>{name}</TextDivider>
      {(!loading && (
        <GalleryContainer>
          <Masonry
            breakpointCols={breakpoints}
            className="grid"
            columnClassName="grid-column"
          >
            {list &&
              list.map((item) => <Parallax title={item.name} loading="lazy" description={item.description} src={item.image} />)}
          </Masonry>
        </GalleryContainer>
      )) || (
          <LoadingContainer variant="masonry" gap={16} cols={6}>
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
              <SkeletonContainer
                variant="rectangular"
                height={utils.height.halfVH}
              />
            ))}
          </LoadingContainer>
        )}
    </Flex>
  );
};

export default CustomWall;
